// Refer to process.env.REACT_APP_ENV directly: CRA's webpack DefinePlugin
// substitutes the literal at build time, so the `process` reference never
// reaches runtime. A `typeof process` guard would defeat that substitution
// under CRA 5 (which no longer shims `process` in the browser).
const reactAppEnv = process.env.REACT_APP_ENV;

let language = '';
let isProduction = false;

let apiUrl = `http://localhost:8000/${language}api`;
let privateApiUrl = `http://localhost:8000/${language}private_api`;

if (reactAppEnv === 'prod') {
  apiUrl = `https://app.investime.fi/${language}api`;
  privateApiUrl = `https://app.investime.fi/${language}private_api`;
  isProduction = true;
} else if (reactAppEnv === 'virala') {
  apiUrl = `https://virala.investime.fi/${language}api`;
  privateApiUrl = `https://virala.investime.fi/${language}private_api`;
  isProduction = true;
} else if (reactAppEnv === 'batofin') {
  apiUrl = `https://batofin.investime.fi/${language}api`;
  privateApiUrl = `https://batofin.investime.fi/${language}private_api`;
  isProduction = true;
} else if (reactAppEnv === 'dev') {
  apiUrl = `https://dev.investime.fi/${language}api`;
  privateApiUrl = `https://dev.investime.fi/${language}private_api`;
} else if (reactAppEnv === 'jk_lenovo') {
  apiUrl = `http://localhost:8000/${language}api`;
} else if (reactAppEnv === 'moltres') {
  apiUrl = `http://127.0.0.1:8000/${language}api`;
} else if (reactAppEnv === 'hardcode') {
  apiUrl = `http://127.0.0.1:8000/${language}api`;
  privateApiUrl = `http://127.0.0.1:8000/${language}private_api`;
}

// An explicit override, so a developer can point the app at a backend on another
// port without editing this file. Nothing in the deployed environments sets it;
// they keep using the REACT_APP_ENV branches above. (Sovellon #2260, finding F-11.)
if (process.env.REACT_APP_API_URL) {
  apiUrl = process.env.REACT_APP_API_URL;
}
if (process.env.REACT_APP_PRIVATE_API_URL) {
  privateApiUrl = process.env.REACT_APP_PRIVATE_API_URL;
}

const config = {
  apiUrl: apiUrl,
  TEST_NO_BACKEND: false,
  isProduction: isProduction,
  privateApiUrl: privateApiUrl,
};

export default config;
